import {
    minimalToast,
    NotificationCategory,
    NotificationPriority,
    NotificationSeverity,
} from "../../utils/toast";
import { AxiosRequest } from "../ApiCall";
import { configEnv } from "../constant";

export const userApi = {
    register: async (body: {
        name: string;
        email: string;
        password: string;
        role: string[];
        picture?: string;
        phone?: string;
    }) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/register`,
                body,
                null
            );
            minimalToast({
                title: "User Registration",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.ALERT,
                priority: NotificationPriority.HIGH,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    registerSuperAdmin: async (body: {
        name: string;
        email: string;
        password: string;
        role: string[];
    }) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/register-super-admin`,
                body,
                null
            );
            minimalToast({
                title: "Super Admin Registration",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.ALERT,
                priority: NotificationPriority.HIGH,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    ownerRegister: async (body: {
        name: string;
        email: string;
        password: string;
        role: string[];
    }) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/owner/owner-register`,
                body,
                null
            );
            minimalToast({
                title: "Owner Registration",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.ALERT,
                priority: NotificationPriority.HIGH,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    bulkRegister: async (body: any, header: any) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/bulk-register`,
                body,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    login: async (body: { email: string; password: string }) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/login`,
                body,
                null
            );
            return data.data;
        } catch (error: any) {
            throw error;
        }
    },
    ownerLogin: async (
        body: { email: string; password: string },
        header: { Authorization?: string }
    ) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/owner/owner-login`,
                body,
                header
            );
            minimalToast({
                title: "Owner Login",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.MESSAGE,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    generateForgetPasswordLink: async (body: { email: string }) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/forget-password`,
                body,
                null
            );
            minimalToast({
                title: "Forget Password",
                message: data.data.message,
                type: NotificationSeverity.INFO,
                category: NotificationCategory.ALERT,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    resetPassword: async (
        body: { password: string; confirmPassword: string },
        token: string
    ) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/reset-password/${token}`,
                body,
                null
            );
            minimalToast({
                title: "Reset Password",
                message: data.data.message,
                type: NotificationSeverity.INFO,
                category: NotificationCategory.ALERT,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    getAuthdetails: async (id: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/teacher/teacher-details/${id}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    getTeacherDetails: async (id: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/teacher/teachers-details/${id}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    getAllTeachersByOrganization: async (
        organizationId: string,
        header: any
    ) => {
        if (!organizationId) {
            console.error("Organization ID is required");
            return;
        }
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/teacher/organization-teacher/${organizationId}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    getProfile: async (id: string, name: string, header: any) => {
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/teacher/profile/${id}/${name}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    getApprovedTeachers: async (header: any) => {
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/teacher/teachers/approved`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    getTeachers: async (header: any) => {
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/teacher/get-all-teachers`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    getTeachersByFilters: async (
        filters: {
            organizationId?: string;
            departmentQuery?: string;
            unitQuery?: string;
        },
        header: any
    ) => {
        try {
            const queryParams = new URLSearchParams(filters).toString();
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/teacher/get-all-teachers-by-filters?${queryParams}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    updateProfilePicture: async (url: string, header: any, cover?: string) => {
        try {
            const data = await AxiosRequest(
                "PUT",
                `${configEnv.baseUrl}/teacher/update-profile-picture`,
                { url, cover },
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    updateProfile: async (
        id: string,
        body: {
            name?: string;
            email?: string;
            phone?: string;
            department?: string;
            unit?: string;
            licenseAccepted?: boolean;
            organizations?: string[];
            licenseId?: string;
            licenseDescription?: string;
        },
        header: any
    ) => {
        try {
            const data = await AxiosRequest(
                "PUT",
                `${configEnv.baseUrl}/teacher/${id}`,
                body,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    updateProfileByAdminOrOwner: async (
        id: string,
        body: {
            name?: string;
            email?: string;
            phone?: string;
            department?: string;
            unit?: string;
            role?: string[];
        },
        header: any
    ) => {
        try {
            const data = await AxiosRequest(
                "PUT",
                `${configEnv.baseUrl}/teacher/update-user-profile-by-admin-or-owner/${id}`,
                body,
                header
            );
            minimalToast({
                title: "Profile Update",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.UPDATE,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    fetchAll: async (header: any) => {
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/teacher`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
    ApproveTeacher: async (id: any, header: any) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/approve-teacher/${id}`,
                null,
                header
            );
            minimalToast({
                title: "Teacher Approval",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.UPDATE,
                priority: NotificationPriority.HIGH,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    sendInvitation: async (body: any, header: any) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/send-invite-to-auditor`,
                body,
                header
            );
            minimalToast({
                title: "Send Invitation",
                message: data.data.message,
                type: NotificationSeverity.SUCCESS,
                category: NotificationCategory.MESSAGE,
                priority: NotificationPriority.MEDIUM,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    RejectTeacher: async (id: any, header: any) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/reject-teacher/${id}`,
                null,
                header
            );
            minimalToast({
                title: "Teacher Rejection",
                message: data.data.message,
                type: NotificationSeverity.ERROR,
                category: NotificationCategory.UPDATE,
                priority: NotificationPriority.HIGH,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    deleteTeacher: async (id: any, header: any) => {
        try {
            const data = await AxiosRequest(
                "DELETE",
                `${configEnv.baseUrl}/teacher/${id}`,
                null,
                header
            );
            minimalToast({
                title: "Delete Teacher",
                message: data.data.message,
                type: NotificationSeverity.ERROR,
                category: NotificationCategory.UPDATE,
                priority: NotificationPriority.HIGH,
            });
            return data.data;
        } catch (error: any) {
        }
    },
    getStatisticsByRole: async (body: any, header: any) => {
        try {
            const data = await AxiosRequest(
                "POST",
                `${configEnv.baseUrl}/teacher/get-statistics-by-role`,
                body,
                header
            );
            return data.data;
        } catch (error) {
        }
    },
    getInvitations: async (organizationId: string, header: any, role?: string) => {
        if (!organizationId) {
            console.error("Organization ID is required");
            return;
        }
        try {
            const data = await AxiosRequest(
                "GET",
                `${configEnv.baseUrl}/teacher/invitations/${organizationId}${role ? `?role=${role}` : ""}`,
                null,
                header
            );
            return data.data;
        } catch (error: any) {
        }
    },
};
